<template>
    <div style="display: flex; flex-direction: column; background: linear-gradient(180deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.601454) 60%, rgba(255, 255, 255, 0.9) 80.4%, #FFFFFF 100%);">
        <div class="header" style="padding-bottom: 10px; position: relative;">
            <div style="left:0px; top:0px; width:100%; height:100%; position: absolute; overflow: hidden; display: flex; align-items: center;">
                <img style="width: 100%; object-fit: cover;" ref="preview" alt="">
                <input type="file" style="display:none;" accept="image/*" @change="readURL($event)" ref="imageFile">
            </div>
            <div style="position:relative; margin-top: 10px; margin-bottom: 20px; padding-left: 20px; display: flex; gap: 4px; align-items: center;" @click="() => { $GlobalStore.closeLastModal() }">
                <img style="width: 10px;" :src="require('@/assets/img/white_arrow.png')" alt="">
                <div style="color: #fff; font-size: 14px; font-weight: 500;">뒤로가기</div>
            </div>
            <div style="position:relative; text-align: center; color: #fff;">
                <div style="font-size: 20px;font-weight: 700;line-height: 24px; margin-bottom: 4px;">멤버톡 만들기</div>
                <div style="font-weight: 500; line-height: 24px;">누구나 자유롭게 소통할 수 있는<br>멤버톡을 만들 수 있습니다</div>
            </div>
            <div @click="setIsShowPopMenu" style="position: absolute; bottom: 12px; right: 12px;">
                <img style="width: 24px;" :src="require('@/assets/img/modify_img.png')" alt="">
            </div>
        </div>
        <div style="flex: 1; padding: 0 12px; overflow-y: scroll; padding-bottom: 30px;">
            <div style="margin-top: 40px;">
                <div class="title">멤버톡 제목</div>
                <input @input="handleTitleLength" v-model="memberTalkInfo.title" placeholder="이름" class="common_input" type="text">
                <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; float: right; margin-top: 6px;">{{ memberTalkInfo.title.length }}/40</div>
            </div>
            <div style="margin-top: 44px;">
                <div class="title">멤버톡 소개</div>
                <textarea @input="handleIntroLength" v-model="memberTalkInfo.introduce" placeholder="소개" class="common_text_area" type="text"></textarea>
                <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; float: right; margin-top: 6px;">{{ memberTalkInfo.introduce.length }}/200</div>
            </div>
            <div v-if="!isExpert" style="margin-top: 44px;">
                <div class="title">연령대</div>
                <div style="display: grid; gap: 10px; grid-template-columns: 1fr 1fr;">
                    <div @click="setAge(each)" :class="changeBackColorAge(each) ? 'select' : ''" v-for="each, i in age" :key="i" style="font-weight: 500; display: flex; align-items: center; gap: 4px;" class="common_box">
                        <span>{{ each }}</span>
                        <img v-if="changeBackColorAge(each)" style="width: 14px;" :src="require('@/assets/img/check_black.png')" alt="">
                    </div>
                </div>
            </div>
            <div style="margin-top: 20px; position: relative">
                <div style="display: flex; justify-content: space-between;">
                    <div class="title">최대 인원</div>
                    <div class="title" @click="selectMaxCnt" v-if="showScroll">완료</div>
                </div>
                <div @click="setShowScroll" v-if="!showScroll" style="display: grid; grid-template-columns: 1fr 1fr;">
                    <div style="font-weight: 500; display: flex; align-items: center; justify-content: space-between;" class="common_box">
                        <div>{{ memberTalkInfo.maxCnt }}명</div>
                        <img style="width: 10px;" :src="require('@/assets/img/arrow_down.png')" alt="">
                    </div>
                </div>
                <div v-else style="display: flex; justify-content: start; z-index: 100; width: 100%;">
                    <CommonScrollSelector style="height:115px; overflow:hidden; flex: 1; z-index: 2;" :list="maxCnt" :detect-value-change="detectValueChange"></CommonScrollSelector>
                    <div style="background-color: #f5f5f5; width: calc(100% - 40px); z-index: 1; border-radius: 7px; height: 30px; position: absolute; left: 50%;top: 38%; transform: translate(-50%, -50%); "></div>
                </div>
            </div>
            <div style="margin-top: 20px;">
                <div class="title">멤버톡 태그</div>
                <div style="font-weight: 500; font-size: 12px; margin-bottom: 12px;">1개를 선택할 수 있습니다</div>
                <div style="display: grid; gap: 10px; grid-template-columns: 1fr 1fr;">
                    <div @click="setTag(each)" :class="changeBackColorTag(each) ? 'select' : ''" v-for="each, i in memberTalkTag" :key="i" style="font-weight: 500; display: flex; align-items: center; gap: 4px;" class="common_box">
                        <span>{{ each }}</span>
                        <img v-if="changeBackColorTag(each)" style="width: 14px;" :src="require('@/assets/img/check_black.png')" alt="">
                    </div>
                </div>
            </div>
            <!-- <div style="margin-top: 37px;">
                <div class="title">멤버톡 참여 형태를 선택하세요</div>
                <div @click="setEnjoyType(ENJOY_TYPE.ANYBODY)" class="common_box" :style="{ border: memberTalkInfo.enjoy_type === ENJOY_TYPE.ANYBODY ? '1px solid var(--color-main)' : '' }" style="display: flex; gap: 12px; align-items: center; margin-bottom: 12px;">
                    <div>
                        <img style="width: 20px;" :src="require('@/assets/img/anybody_select.png')" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; margin-bottom: 6px;">누구나 참여 가능</div>
                        <div style="color: #606060; font-weight: 500; font-size: 12px;">누구든 멤버톡에 참여할 수 있습니다.</div>
                    </div>
                </div>
                <div @click="setEnjoyType(ENJOY_TYPE.PRIVATE)" class="common_box" :style="{ border: memberTalkInfo.enjoy_type === ENJOY_TYPE.PRIVATE ? '1px solid var(--color-main)' : '' }" style="display: flex; gap: 12px; align-items: center;">
                    <div>
                        <img style="width: 21px;" :src="require('@/assets/img/private.png')" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; margin-bottom: 6px;">비공개</div>
                        <div style="color: #606060; font-weight: 500; font-size: 12px;">초대 혹은 비밀번호 입력 시 참여할 수 있습니다.</div>
                    </div>
                </div>
            </div> -->
        </div>
        <div style=" padding: 0 12px; padding-bottom: 40px;">
            <CommonBottomBtn :unActiveColor="'#d9d9d9'" :isActive="isActive" :btnClickEvent="makeMemberTalk" :btnName="'만들기'"></CommonBottomBtn>
        </div>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
    </div>
</template>

<script>
import CommonBottomBtn from '@/components/common/CommonBottomBtn.vue';
import { ENJOY_TYPE } from '@/Constants';
import ResponseCode from '@/ResponseCode';
import CommonScrollSelector from '@/components/common/CommonScrollSelector'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'

export default {
    name: 'MakeMemberTalk',
    components: { CommonBottomBtn, CommonScrollSelector, BottomPopupMenu },
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            memberTalkInfo: {
                title: '',
                introduce: '',
                age: [],
                maxCnt: 0,
                tag: []
            },
            memberTalkTag: ['매치 뛰기', '용병 모집', '조기축구', '친목', '국내축구', '해외축구', '팬클럽', '경기 직관', '레슨', '훈련', '유소년', '여자축구'],
            ENJOY_TYPE: ENJOY_TYPE,
            age: ['10대', '20대', '30대', '40대', '50대', '60대 이상'],
            maxCnt: [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 40, value: 40 },
                { label: 50, value: 50 },
                { label: 60, value: 60 },
                { label: 70, value: 70 },
            ],
            showScroll: false,
            isShowPopMenu: false,
            menuOptions: {},
            public_img_path: '',
        }
    },
    created() {
        if (this.$Util.isShowDefaultSettings()) {
            return
        }

        if (this.isExpert) {
            this.memberTalkTag = ['훈련', '레슨', '유소년', '여자축구']
        }
    },
    computed: {
        isExpert() {
            if (this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                return true
            } else {
                return false
            }
        },
        isExpertConfirmed() {
            if (this.$GlobalStore.loginInfo().is_coach === '1') {
                return true
            } else {
                return false
            }
        },
        isActive() {
            const condition = this.memberTalkInfo.title !== ''
                && this.memberTalkInfo.introduce !== ''
                && this.memberTalkInfo.age.length > 0
                && this.memberTalkInfo.maxCnt > 0
                && this.memberTalkInfo.tag.length > 0
            if (condition) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        readURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        this.$refs['preview'].src = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                }
            }
        },
        changeBackColorTag(tag) {
            return this.memberTalkInfo.tag.includes(tag)
        },
        detectValueChange(selectedData) {
            this.memberTalkInfo.maxCnt = selectedData.value
        },
        selectMaxCnt() {
            this.showScroll = false
        },
        setShowScroll() {
            this.showScroll = true
        },
        // setAge(age) {
        //     if (age === '60대 이상') {
        //         this.memberTalkInfo.age = [age];
        //     } else {
        //         if (this.memberTalkInfo.age.includes('60대 이상')) {
        //             this.memberTalkInfo.age = this.memberTalkInfo.age.filter(selectedAges => selectedAges !== '60대 이상');
        //             this.memberTalkInfo.age.push(age);
        //         } else {
        //             if (this.memberTalkInfo.age.includes(age)) {
        //                 this.memberTalkInfo.age = this.memberTalkInfo.age.filter(selectedAges => selectedAges !== age);
        //             } else {
        //                 this.memberTalkInfo.age.push(age);
        //             }
        //         }
        //     }
        // },
        // setTag(tag) {
        //     if (this.memberTalkInfo.tag.includes(tag)) {
        //         this.memberTalkInfo.tag = this.memberTalkInfo.tag.filter(selectedTag => selectedTag !== tag)
        //     } else {
        //         if (this.memberTalkInfo.tag.length === 3) {
        //             alert('멤버톡 태그는 최대 3개까지 설정이 가능합니다.')
        //             return
        //         }
        //         this.memberTalkInfo.tag.push(tag)
        //     }
        // },
        changeDefaultImage() {
            let randomNum;
            let public_img_path;
            randomNum = Math.floor(Math.random() * (30 - 7 + 1)) + 7
            if (1 <= randomNum && randomNum < 10) {
                randomNum = '0' + randomNum
            }
            public_img_path = `/img/membertalk/membertalk_default_image_${randomNum}.jpg`
            this.public_img_path = public_img_path
            this.$refs.preview.src = public_img_path;

        },
        changeDefaultImageSquad() {
            let randomNum;
            let public_img_path
            randomNum = parseInt(Math.random() * 6) + 1
            randomNum = '0' + randomNum
            public_img_path = `/img/membertalk/membertalk_default_image_${randomNum}.jpg`
            this.public_img_path = public_img_path
            this.$refs.preview.src = public_img_path;
        },
        setIsShowPopMenu() {
            this.isShowPopMenu = true
            const labelAndAction = []

            labelAndAction.push(
                {
                    label: '기본 이미지로 변경', action: () => {
                        this.changeDefaultImage()
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '스쿼드 이미지로 변경', action: () => {
                        this.changeDefaultImageSquad()
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '앨범에서 선택', action: () => {
                        this.$refs.imageFile.click();
                        this.isShowPopMenu = false
                    },
                },
            )


            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        setTag(tag) {
            if (this.memberTalkInfo.tag[0] === tag) {
                this.memberTalkInfo.tag = []
                return
            }
            this.memberTalkInfo.tag = [tag]
        },
        setAge(age) {
            if (this.memberTalkInfo.age[0] === age) {
                this.memberTalkInfo.age = []
                return
            }
            this.memberTalkInfo.age = [age]
        },
        changeBackColorAge(age) {
            return this.memberTalkInfo.age.includes(age)
        },
        handleTitleLength() {
            if (this.memberTalkInfo.title.length > 40) {
                this.memberTalkInfo.title = this.memberTalkInfo.title.slice(0, 40)
            }
        },
        handleIntroLength() {
            if (this.memberTalkInfo.introduce.length > 200) {
                this.memberTalkInfo.introduce = this.memberTalkInfo.introduce.slice(0, 200)
            }
        },
        setEnjoyType(type) {
            this.memberTalkInfo.enjoy_type = type
        },
        async makeMemberTalk() {
            if (this.memberTalkInfo.title === null || this.memberTalkInfo.title === '') {
                this.$GlobalStore.showAlert('멤버톡의 이름을 입력해주세요.')
                return
            }

            if (this.memberTalkInfo.introduce === null || this.memberTalkInfo.introduce === '') {
                this.$GlobalStore.showAlert('멤버톡의 소개를 입력해주세요.')
                return
            }

            if (this.memberTalkInfo.age.length === 0 && !this.isExpert) {
                this.$GlobalStore.showAlert('멤버톡의 연령대를 선택해주세요.')
                return
            }

            if (this.memberTalkInfo.maxCnt === 0) {
                this.$GlobalStore.showAlert('멤버톡의 최대 인원을 선택해주세요.')
                return
            }

            if (this.memberTalkInfo.tag.length === 0) {
                this.$GlobalStore.showAlert('멤버톡의 태그를 선택해주세요.')
                return
            }

            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('mode', 'insert')
            formData.append('title', this.memberTalkInfo.title)
            formData.append('introduce', this.memberTalkInfo.introduce)
            formData.append('max_cnt', this.memberTalkInfo.maxCnt)
            formData.append('join_tag', this.memberTalkInfo.tag.join(', '))
            formData.append('img_public_path', this.public_img_path)

            if (!this.isExpert) {
                formData.append('age', this.memberTalkInfo.age.join(', '))
            }

            if (this.$refs.imageFile.value !== '') {
                formData.append('file0', this.$refs.imageFile.files[0])
            }

            const res = await this.$Axios.post('/api/join/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$Util.sendEventClick('멤버톡_생성', true)
                this.showGroupChatting(res.data.chat_idx, res.data.join_idx)
                this.completeAction();
            } else {
                console.log(res)
            }
            this.$GlobalStore.hideProgress()
        },
        async showGroupChatting(chat_idx, join_idx) {
            join_idx;
            this.$GlobalStore.closeLastModal();
            await this.$Axios.showChattingBySoccerJoinIdx(chat_idx)
            // const isPrivate = this.memberTalkInfo.enjoy_type === JOIN_WAY.APPROVE ? true : false
            // const res = await this.$Axios.get('/api/chat/auth', { params: { chat_idx: chat_idx } });
            // if (res.data.code === 0) {
            //     this.$GlobalStore.closeLastModal()
            //     this.$GlobalStore.addModal('JoinChat', {
            //         isNewMemberTalk: isPrivate, auth: res.data.auth, chat: res.data.chat, chatIdx: chat_idx,
            //         pTitle: this.memberTalkInfo.title, init_refer_idx: join_idx, completeAction: this.getJoinChats, user : res.data.user });
            // }
        }
    }
}
</script>

<style scoped>
.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

.common_input {
    padding: 10px;
    padding-left: 12px;
    outline: none;
    width: 100%;
    border-radius: 12px;
    border: none;
    background-color: #f5f5f5;
}

.common_input::placeholder {
    color: #bbbbbb;
    font-weight: 700;
}

.select {
    background-color: var(--color-main);
}

.title {
    font-weight: 700;
    line-height: 23px;
    margin-bottom: 8px;
    font-size: 14px;
}

.common_text_area {
    padding: 10px;
    padding-left: 12px;
    outline: none;
    width: 100%;
    min-height: 72px;
    border-radius: 12px;
    border: none;
    resize: none;
    line-height: 23px;
    background-color: #f5f5f5;
}

.common_text_area::placeholder {
    color: #bbbbbb;
    font-weight: 700;
}

.header {
    background-image: linear-gradient(180deg, rgba(33, 15, 3, 0) 0%, rgba(33, 15, 3, 0.7) 70%, #210F03 100%),
        url('~@/assets/img/sample.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}
</style>